export default __webpack_public_path__ + "static/Cervejas-biritis-f8a3ec9d597ca4c80b65f536b32e156f.jpg";